import React from 'react'
import PropTypes from 'prop-types'

export default function Svg ({ href, className, ...props }) {
  return (
    <svg className={className || 'Svg-root'} {...props}>
      <use href={`${href}`}/>
    </svg>
  )
}

Svg.propTypes = {
  href: PropTypes.string.isRequired,
  className: PropTypes.string
}
